import * as actions from '../actions';
import * as translationActions from '../translationActions';
import HttpService from '../../services/HttpService';

const initialState = {
  isLogged: false,
  isAutoLock: false,
  isSuspended: false,
  user: null,
};

const check = (state, payload) => {
  state = Object.assign({}, state, {
    ...payload,
    isSuspended: !!payload.is_suspended,
  });
  return state;
};

const login = (state, payload) => {
  const jwtToken = payload.access_token;

  localStorage.setItem('access_token', jwtToken);
  HttpService.setDefaultHeader('Authorization', `Bearer ${jwtToken}`);

  const user = {
    id: payload.user.id,
    name: payload.user.name,
    surname: payload.user.surname,
    avatar: payload.user.avatar,
    role: payload.user.role,
    permissions: payload.user.permissions,
    email: payload.user.email,
  };

  state = Object.assign({}, state, {
    isLogged: true,
    isAutoLock: false,
    isSuspended: !!payload.is_suspended,
    user,
  });

  return state;
};

const update = (state, payload) => {
  const { user } = state;
  const get = (key) => {
    if (payload.user.hasOwnProperty(key)) {
      return payload.user[key];
    }

    return user[key];
  };

  user.id = get('id');
  user.name = payload.user.data.name;
  user.surname = payload.user.data.surname;
  user.avatar = payload.user.data.avatar;
  user.email = payload.user.data.email;

  state = Object.assign({}, state, {
    isLogged: true,
    isAutoLock: false,
    isSuspended: state.isSuspended,
    user: { ...user },
  });

  return state;
};

const update_my_user_role_translations = (state, payload) => {
  state = Object.assign({}, state, {
    user: { ...state.user, role: payload.role },
  });

  return state;
};

const logout = (state) => {
  localStorage.removeItem('visitor_id');
  localStorage.removeItem('access_token');
  HttpService.removeDefaultHeader('Authorization');

  state = Object.assign({}, state, {
    isLogged: false,
    isAutoLock: false,
    isSuspended: false,
    user: null,
  });

  return state;
};

const autoLock = (state) => {
  localStorage.removeItem('access_token');
  HttpService.removeDefaultHeader('Authorization');

  state = Object.assign({}, state, {
    isAutoLock: true,
  });

  return state;
};

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.AUTH_CHECK:
      return check(state, payload);

    case actions.AUTH_LOGIN:
      return login(state, payload);

    case actions.AUTH_LOGOUT:
      return logout(state);

    case actions.AUTO_LOCK:
      return autoLock(state);

    case actions.AUTH_UPDATE:
      return update(state, payload);

    case translationActions.UPDATE_USER_ROLE_TRANSLATIONS:
      return update_my_user_role_translations(state, payload);
  }
  return state;
};
